import axios from 'axios';
import toCamelCase from '@/helpers/toCamelCase';
import cloneDeep from 'lodash/cloneDeep';

export const state = () => ({
    items: []
});

export const getters = {
    items: state => state.items.filter(item => !item.dismissed).sort((a, b) => b.id > a.id ? 1 : -1),
    dismissedItems: state => state.items.filter(item => item.dismissed).sort((a, b) => b.id > a.id ? 1 : -1),
    unreadItems: state => state.items.filter(item => !item.readAt && !item.dismissed)
};

export const mutations = {
    SET_ITEMS(state, items) {
        state.items = items;
    },

    UPDATE_ITEM(state, item) {
        const index = state.items.findIndex(i => i.id === item.id);
        state.items.splice(index, 1, cloneDeep(item));
    }
};

export const actions = {
    async getItems({ commit }) {
        const items = await axios.$get('/v1/notifications');

        commit('SET_ITEMS', toCamelCase(items));
    },

    async update({ commit }, { id, dismissed }) {
        const notification = await axios.$patch(`/v1/notifications/${id}`, {
            dismissed
        });

        commit('UPDATE_ITEM', toCamelCase(notification));

        return notification;
    },

    async markAsRead({ commit, getters }, payload) {
        const items = await axios.$post('/v1/notifications/mark_as_read', payload);

        items.forEach((item) => {
            let existingItem = getters.items.find(existingItem => existingItem.id === item.id);
            existingItem.readAt = toCamelCase(item).readAt;
            commit('UPDATE_ITEM', existingItem);
        });
    },
};
